export const RANK_COLORS = {
  1: '#ff5d9d',
  2: '#ffc013',
  3: '#62c9ff',
}

const WEEK_ACT_WEEK_DIFFS = ['0', '1', '2', '3']
export function getWeekActWeekDiff(timeTabIndex) {
  return WEEK_ACT_WEEK_DIFFS[timeTabIndex] || WEEK_ACT_WEEK_DIFFS[0]
}

export function mapInviteRewardCfgList(list) {
  const sorted = [...(list || [])].sort((a, b) => a.inviteCount - b.inviteCount)
  return sorted.map((item, index) => ({
    minBeans: item.inviteCount ?? 0,
    rewardBean: item.rewardBean ?? 0,
    maxBeans: sorted[index + 1]?.inviteCount,
  }))
}

export function calcUnlockedBonus(inviteCount, cfgList) {
  const sorted = [...(cfgList || [])].sort((a, b) => a.inviteCount - b.inviteCount)
  let bonus = 0
  for (const tier of sorted) {
    if (inviteCount >= tier.inviteCount) {
      bonus = tier.rewardBean ?? 0
    }
  }
  return bonus
}

export function calcRemainingToUnlock(inviteCount, cfgList) {
  const sorted = [...(cfgList || [])].sort((a, b) => a.inviteCount - b.inviteCount)
  const next = sorted.find((tier) => tier.inviteCount > inviteCount)
  return next ? next.inviteCount - inviteCount : 0
}

export function calcNextTierRewardBean(inviteCount, cfgList) {
  const sorted = [...(cfgList || [])].sort((a, b) => a.inviteCount - b.inviteCount)
  const next = sorted.find((tier) => tier.inviteCount > inviteCount)
  return next?.rewardBean ?? 0
}

export function mapSubAgentRankList(list) {
  return (list || []).map((item, index) => ({
    rank: index + 1,
    nickname: item.nickName || '',
    avatar: item.avatar || '',
    invites: item.inviteCount ?? 0,
  }))
}

export function formatEventTimeRange(actStart, actEnd, handleMoment) {
  if (!actStart || !actEnd || !handleMoment) return ''
  const start = handleMoment(actStart, 'D MMM')
  const end = handleMoment(actEnd, 'D MMM YYYY')
  return `${start} – ${end}`
}

export function mapWeekActResponse(data) {
  const inviteCount = data?.inviteCount ?? 0
  const cfgList = data?.inviteRewardCfgList || []
  const actStart = data?.actStart ?? 0
  const actEnd = data?.actEnd ?? 0
  return {
    verifiedHostesses: inviteCount,
    unlockedBonus: calcUnlockedBonus(inviteCount, cfgList),
    settled: actEnd > 0 && actEnd < Date.now(),
    percentCount: inviteCount,
    remainingToUnlock: calcRemainingToUnlock(inviteCount, cfgList),
    nextTierRewardBean: calcNextTierRewardBean(inviteCount, cfgList),
    earnTypeList: mapInviteRewardCfgList(cfgList),
    actStart,
    actEnd,
  }
}

export function formatCarouselTimeLabel(timestamp, now = Date.now()) {
  if (!timestamp) {
    return { langKey: 'lang.SubAgentEvent.k022', numsOption: [] }
  }
  const diffMs = now - timestamp
  if (diffMs < 3600000) {
    return { langKey: 'lang.SubAgentEvent.k022', numsOption: [] }
  }
  const eventDay = new Date(timestamp)
  const yesterday = new Date(now)
  yesterday.setDate(yesterday.getDate() - 1)
  if (
    eventDay.getFullYear() === yesterday.getFullYear() &&
    eventDay.getMonth() === yesterday.getMonth() &&
    eventDay.getDate() === yesterday.getDate()
  ) {
    return { langKey: 'lang.CommonModule.k030', numsOption: [] }
  }
  const hours = Math.max(1, Math.floor(diffMs / 3600000))
  return { langKey: 'lang.SubAgentEvent.k023', numsOption: [{ value: hours }] }
}

export function mapCarouselItem(item, now = Date.now()) {
  const type = item.type === 1 ? 1 : 2
  return {
    timeLabel: formatCarouselTimeLabel(item.time, now),
    messageLangKey: type === 1 ? 'lang.SubAgentEvent.k020' : 'lang.SubAgentEvent.k021',
    messageNumsOption: [{ value: item.nickName || '' }],
  }
}

export function mapCarouselList(list, now = Date.now()) {
  return (list || []).map((item) => mapCarouselItem(item, now))
}
